import { jsx as _jsx } from "react/jsx-runtime";
import { isRtl } from 'libs.i18n-core';
/**
 * A container component that sets the text direction based on the locale.
 */
export const DirContainer = ({ children, locale }) => {
    const dir = isRtl(locale) ? 'rtl' : 'ltr';
    return (_jsx("div", { dir: dir, style: { height: '100%' }, children: children }));
};
//# sourceMappingURL=dir_container.js.map